<template>
  <div class="page-container">
    <div class="page-header">
      <h2>管理员管理</h2>
    </div>

    <div class="filter-bar">
      <el-select v-model="filterForm.roleType" placeholder="角色类型" size="small" style="width: 150px;">
        <el-option label="全部" :value="undefined" />
        <el-option label="系统管理员" :value="SYSTEM_ADMIN" />
        <el-option label="服务商管理员" :value="SERVICE_PROVIDER" />
        <el-option label="小程序管理员" :value="PLATFORM" />
      </el-select>
      <el-input
        v-model="filterForm.username"
        placeholder="用户名"
        size="small"
        style="width: 200px; margin-left: 10px;"
      />
      <el-select v-model="filterForm.status" placeholder="状态" size="small" style="width: 120px; margin-left: 10px;">
        <el-option label="全部" :value="undefined" />
        <el-option label="正常" :value="1" />
        <el-option label="禁用" :value="0" />
      </el-select>
      <el-button type="primary" size="small" style="margin-left: 10px;" @click="loadData">查询</el-button>
      <el-button type="default" size="small" style="margin-left: 10px;" @click="handleReset">重置</el-button>
      <el-button type="success" size="small" style="margin-left: 10px;" @click="showAddDialog">新增管理员</el-button>
    </div>

    <el-table :data="list" v-loading="loading" border stripe>
      <el-table-column prop="id" label="ID" width="80" align="center" />
      <el-table-column prop="username" label="用户名" width="120" />
      <el-table-column prop="realName" label="真实姓名" width="120" />
      <el-table-column prop="phone" label="手机号" width="120" />
      <el-table-column prop="email" label="邮箱" width="150" />
      <el-table-column label="角色类型" width="140" align="center">
        <template slot-scope="scope">
          <el-tag :type="getRoleTypeTag(scope.row.roleType)" size="small">
            {{ getRoleTypeName(scope.row.roleType) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="所属" width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.serviceProviderName">{{ scope.row.serviceProviderName }}</span>
          <span v-else-if="scope.row.miniAppName">{{ scope.row.miniAppName }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'warning'" size="small">
            {{ scope.row.status === 1 ? '正常' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="lastLoginAt" label="最后登录" width="160" align="center" />
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="editRow(scope.row)">编辑</el-button>
          <el-button
            type="text"
            size="small"
            :style="scope.row.status === 1 ? 'color: #F56C6C;' : 'color: #67C23A;'"
            @click="toggleStatus(scope.row)"
          >{{ scope.row.status === 1 ? '禁用' : '启用' }}</el-button>
          <el-button
            type="text"
            size="small"
            style="color: #F56C6C;"
            @click="deleteRow(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    />

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="form.id ? '编辑管理员' : '新增管理员'" :visible.sync="showDialog" width="500px">
      <el-form :model="form" label-width="80px">
        <el-form-item label="角色类型" prop="roleType">
          <el-select v-model="form.roleType" placeholder="请选择角色类型" style="width: 100%;">
            <el-option
              v-for="role in allowedRoles"
              :key="role.value"
              :label="role.label"
              :value="role.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="用户名" prop="username">
          <el-input v-model="form.username" placeholder="请输入用户名" :disabled="form.id" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="form.password" type="password" placeholder="请输入密码" :placeholder="form.id ? '不填则保持不变' : '请输入密码'" />
        </el-form-item>
        <el-form-item label="真实姓名" prop="realName">
          <el-input v-model="form.realName" placeholder="请输入真实姓名" />
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="form.email" placeholder="请输入邮箱" />
        </el-form-item>
        <el-form-item label="所属服务商" v-if="form.roleType === 'SERVICE_PROVIDER'">
          <el-select v-model="form.serviceProviderId" placeholder="请选择服务商" style="width: 100%;">
            <el-option v-for="sp in serviceProviders" :key="sp.id" :label="sp.name" :value="sp.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="所属小程序" v-if="form.roleType === 'PLATFORM'">
          <el-select v-model="form.miniAppId" placeholder="请选择小程序" style="width: 100%;">
            <el-option v-for="app in miniApps" :key="app.id" :label="app.name" :value="app.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="0" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showDialog = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="handleSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAdminPage, getAllowedRoles, createAdmin, updateAdmin, deleteAdmin, updateAdminStatus } from '@/api/admin'
import { getServiceProviderList } from '@/api/serviceProvider'
import { getMiniAppList } from '@/api/miniApp'

export default {
  name: 'AdminList',
  data() {
    return {
      SYSTEM_ADMIN: 'SYSTEM_ADMIN',
      SERVICE_PROVIDER: 'SERVICE_PROVIDER',
      PLATFORM: 'PLATFORM',
      serviceProviders: [],
      miniApps: [],
      allowedRoles: [],
      filterForm: {
        roleType: '',
        username: '',
        status: ''
      },
      list: [],
      page: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      showDialog: false,
      saving: false,
      form: {
        id: null,
        roleType: 'PLATFORM',
        username: '',
        password: '',
        realName: '',
        phone: '',
        email: '',
        serviceProviderId: '',
        miniAppId: '',
        status: 1
      }
    }
  },
  mounted() {
    this.loadServiceProviders()
    this.loadMiniApps()
    this.loadAllowedRoles()
    this.loadData()
  },
  methods: {
    getRoleTypeName(roleType) {
      return roleTypeMap[roleType] || roleType
    },
    getRoleTypeTag(roleType) {
      return roleTypeTagMap[roleType] || 'info'
    },
    async loadAllowedRoles() {
      try {
        const res = await getAllowedRoles()
        this.allowedRoles = res.data || []
        // 设置默认角色为第一个可选项
        if (this.allowedRoles.length > 0 && !this.form.roleType) {
          this.form.roleType = this.allowedRoles[0].value
        }
      } catch (e) {
        this.$message.error('加载角色权限失败')
      }
    },
    async loadServiceProviders() {
      try {
        const res = await getServiceProviderList()
        this.serviceProviders = res.data || []
      } catch (e) {
        this.$message.error('加载服务商失败')
      }
    },
    async loadMiniApps() {
      try {
        const res = await getMiniAppList()
        this.miniApps = res.data || []
      } catch (e) {
        this.$message.error('加载小程序失败')
      }
    },
    async loadData() {
      this.loading = true
      try {
        const res = await getAdminPage({
          page: this.page,
          pageSize: this.pageSize,
          roleType: this.filterForm.roleType || undefined,
          username: this.filterForm.username || undefined,
          status: this.filterForm.status || undefined
        })
        this.list = res.data?.records || res.data?.list || []
        this.total = res.data?.total || 0
      } catch (e) {
        this.$message.error('加载失败')
      } finally {
        this.loading = false
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.loadData()
    },
    handleReset() {
      this.filterForm = {
        roleType: '',
        username: '',
        status: ''
      }
      this.loadData()
    },
    showAddDialog() {
      this.form = {
        id: null,
        roleType: 'PLATFORM',
        username: '',
        password: '',
        realName: '',
        phone: '',
        email: '',
        serviceProviderId: '',
        miniAppId: '',
        status: 1
      }
      this.showDialog = true
    },
    editRow(row) {
      this.form = {
        id: row.id,
        roleType: row.roleType,
        username: row.username,
        password: '',
        realName: row.realName,
        phone: row.phone,
        email: row.email,
        serviceProviderId: row.serviceProviderId,
        miniAppId: row.miniAppId,
        status: row.status
      }
      this.showDialog = true
    },
    async handleSave() {
      if (!this.form.roleType) {
        this.$message.warning('请选择角色类型')
        return
      }
      if (!this.form.username) {
        this.$message.warning('请输入用户名')
        return
      }
      if (!this.form.id && !this.form.password) {
        this.$message.warning('请输入密码')
        return
      }
      if (this.form.roleType === 'SERVICE_PROVIDER' && !this.form.serviceProviderId) {
        this.$message.warning('请选择服务商')
        return
      }
      if (this.form.roleType === 'PLATFORM' && !this.form.miniAppId) {
        this.$message.warning('请选择小程序')
        return
      }
      this.saving = true
      try {
        const data = { ...this.form }
        // 清理不相关的字段，确保传 null 而不是空字符串
        if (data.roleType === 'SYSTEM_ADMIN') {
          data.serviceProviderId = null
          data.miniAppId = null
        } else if (data.roleType === 'SERVICE_PROVIDER') {
          data.miniAppId = null
        } else if (data.roleType === 'PLATFORM') {
          data.serviceProviderId = null
        }
        // 空字符串转为 null
        if (data.serviceProviderId === '') data.serviceProviderId = null
        if (data.miniAppId === '') data.miniAppId = null
        if (!data.password) {
          delete data.password
        }
        if (this.form.id) {
          await updateAdmin(this.form.id, data)
        } else {
          await createAdmin(data)
        }
        this.$message.success('保存成功')
        this.showDialog = false
        this.loadData()
      } catch (e) {
        this.$message.error(e.message || '保存失败')
      } finally {
        this.saving = false
      }
    },
    async toggleStatus(row) {
      try {
        const newStatus = row.status === 1 ? 0 : 1
        await updateAdminStatus(row.id, newStatus)
        row.status = newStatus
        this.$message.success(newStatus === 1 ? '已启用' : '已禁用')
      } catch (e) {
        this.$message.error(e.message || '操作失败')
      }
    },
    async deleteRow(row) {
      try {
        const res = await this.$confirm('确定删除该管理员？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        if (res === 'confirm') {
          await deleteAdmin(row.id)
          this.$message.success('删除成功')
          this.loadData()
        }
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error(e.message || '删除失败')
        }
      }
    }
  }
}
</script>

<style scoped>
.page-container {
  padding: 20px;
}
.page-header {
  margin-bottom: 20px;
}
.page-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
}
.filter-bar {
  margin-bottom: 20px;
  padding: 15px 20px;
  background: #f8f9fa;
  border-radius: 8px;
}
</style>
